<template>
  <a-card id="StudentsManage">
    <div class="search">
      <a-form-model layout="inline" :model="searchForm" class="search-form">
        <a-form-model-item label="所属机构">
          <a-select @change="getGradeList" :filter-option="filterOption" allowClear showSearch v-model="searchForm.organizationId" placeholder="请选择机构">
            <a-select-option :value="item.id" v-for="item in organizationList">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="年级班级">
          <a-cascader
            :options="searchGradeList"
            change-on-select
            v-model="searchForm.gradeClass"
            :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
            placeholder="请选择年级班级"
            @change="searchGradeChange"
            allowClear
          />
        </a-form-model-item>
        <a-form-model-item label="学生姓名">
          <a-input :maxLength="30" v-model.trim="searchForm.realName" placeholder="请输入学生姓名" />
        </a-form-model-item>
        <a-form-model-item label="学生手机号">
          <a-input :maxLength="11" v-model.trim="searchForm.mobile" placeholder="请输入学生手机号" />
        </a-form-model-item>
        <a-form-model-item style="margin-right: 35px">
          <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询 </a-button>
          <a-button @click="searchReset" style="margin-left: 10px"> 重置 </a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="deleteAll" type="danger" icon="delete" v-permission="`studentsManage.Delete`" style="margin-right: 15px">批量删除 </a-button>
          <a-button type="primary" @click="mergeStudent" v-permission="`studentsManage.Merge`"> 合并学生 </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <a-table
      style="min-width: 800px"
      :columns="columns"
      :rowKey="(record) => JSON.stringify(record)"
      :row-selection="rowSelection"
      :pagination="tableRelevant.tablePagination"
      :loading="tableRelevant.tableLoading"
      :locale="tableRelevant.locale"
      :dataSource="tableRelevant.tableDataSource"
    >
      <span slot="gender" slot-scope="text, record">
        {{ text.gender === 1 ? '男' : '女' }}
      </span>
      <span slot="gradeName" slot-scope="text, record">
        {{ text.gradeClassList[0] ? text.gradeClassList[0].gradeName : '' }}
      </span>
      <div style="max-width: 250px" slot="className" slot-scope="text, record">
        <div class="self_td" v-for="(item, index) in record.gradeClassList" :key="item.id">
          {{ item.className }}
        </div>
      </div>
      <span slot="birthday" slot-scope="text, record">
        {{ text.birthday && text.birthday.split(' ')[0] }}
      </span>
      <span v-auth="`studentsManage.Status`" slot="enabled" slot-scope="text, record">
        <a-switch @change="tableStatusChange(text)" :disabled="!text.canOperate" v-model="text.enabled" checked-children="启用" un-checked-children="禁用" />
      </span>
      <div slot="action" class="action" slot-scope="text, record">
        <a-button type="link" :loading="text.loading" :disabled="!text.canOperate" v-permission="`studentsManage.Edit`" icon="edit" @click="edit(text)"> 编辑 </a-button>

        <a-button :disabled="!text.canOperate" type="link" icon="user" @click="studentDetail(text)"> 用户详情 </a-button>
        <a-popconfirm :disabled="!text.canOperate" title="确认要删除此学生吗？" @confirm="del(text)" ok-text="确认" cancel-text="取消">
          <a-button :disabled="!text.canOperate" type="link" icon="delete" class="c-red" danger v-permission="`studentsManage.Delete`"> 删除 </a-button>
        </a-popconfirm>
      </div>
    </a-table>

    <!--添加学生-->
    <a-modal :centered="true" v-model="studentRelevant.visible" width="600px" destroyOnClose @ok="studentRelevantOk" :confirm-loading="studentRelevant.confirmLoading" @cancel="studentRelevantCancel">
      <a-form-model
        ref="studentRelevantForm"
        style="max-height: 400px; overflow-y: auto"
        :labelCol="{ span: 6 }"
        :wrapperCol="{ span: 17 }"
        :model="studentRelevant.data"
        :rules="studentRelevant.rules"
      >
        <!-- <a-form-model-item label="测试用户" prop="testUser" ref="testUser">
                    <a-switch v-model="studentRelevant.data.testUser" checked-children="是" un-checked-children="否"/>
                </a-form-model-item> -->
        <a-form-model-item label="头像" style="margin-bottom: 0">
          <a-upload
            name="imgFile"
            accept="image/png, image/jpeg, image/jpg"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="uploadAction"
            :before-upload="headBeforeUpload"
            @change="headHandleChange"
          >
            <img v-if="studentRelevant.data.faceUrl" :src="studentRelevant.data.faceUrl | filterUrl" style="width: 120px; height: 120px" alt="avatar" />
            <div v-else>
              <a-icon :type="studentRelevant.uploadLoading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传头像</div>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="年级" prop="gradeId" ref="gradeId">
          <a-select v-model="studentRelevant.data.gradeId" @change="getClassList" placeholder="请选择年级">
            <a-select-option :value="item.id" :key="item.id" v-for="item in studentRelevant.gradeList">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="行政班">
          <a-select allowClear placeholder="请选择班级" :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="studentRelevant.data.administrationClassId">
            <a-select-option v-for="item in classList.admin" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="教学班">
          <a-select placeholder="请选择班级" allowClear :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="studentRelevant.data.classIds" mode="multiple">
            <a-select-option v-for="item in classList.teach" :disabled="item.disabled" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="姓名" prop="realName">
          <a-input @change="(e) => (studentRelevant.data.realName = e.target.value.replace(/[^·A-Za-z0-9\u4e00-\u9fa5]*/g, ''))" v-model="studentRelevant.data.realName" placeholder="请输入学生姓名" />
        </a-form-model-item>
        <a-form-model-item label="性别">
          <a-radio-group v-model="studentRelevant.data.gender">
            <a-radio value="1">男</a-radio>
            <a-radio value="2">女</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="身份证号" prop="idCard">
          <a-input v-model="studentRelevant.data.idCard" placeholder="请输入身份证号" />
        </a-form-model-item>
        <a-form-model-item label="学籍号" prop="studentNumber">
          <a-input @change="(e) => (studentRelevant.data.studentNumber = e.target.value.replace(/[^[0-9]*/g, ''))" v-model="studentRelevant.data.studentNumber" placeholder="请输入学籍号" />
        </a-form-model-item>
        <a-form-model-item label="出生日期" prop="birthday" ref="birthday">
          <a-date-picker
            placeholder="请选择出生日期"
            format="YYYY-MM-DD"
            :getCalendarContainer="() => $refs.gradeId.$el"
            v-model="studentRelevant.data.birthday"
            @change="$refs.studentRelevantForm.validateField('birthday')"
            :disabled-date="(current) => (current && current > moment().endOf('day')) || (current && current < moment('1970-01-01'))"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item label="手机号" prop="mobile">
          <a-input v-model="studentRelevant.data.mobile" placeholder="请输入手机号" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="studentRelevant.data.enabled">
            <a-radio value="true">启用</a-radio>
            <a-radio value="false">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 合并课程 -->
    <a-modal width="90%" title="合并学生" :visible="merge.visible" @cancel="closeMerge" @ok="submitMerge" :confirm-loading="merge.confirmLoading">
      <!-- 选择学生 -->
      <div v-if="selectedRowKeys.length">
        <a-table
          row-key="id"
          :columns="mergeColumns"
          :row-selection="mergeSelection"
          :pagination="merge.tableRelevant.tablePagination"
          :loading="merge.tableRelevant.tableLoading"
          :locale="merge.tableRelevant.locale"
          :data-source="merge.tableRelevant.tableDataSource"
        >
          <span slot="gender" slot-scope="text, record">
            {{ text.gender === 1 ? '男' : '女' }}
          </span>
          <span slot="gradeName" slot-scope="text, record">
            {{ text.gradeClassList[0].gradeName }}
          </span>
          <div style="max-width: 250px" slot="className" slot-scope="text, record">
            <div class="self_td" v-for="(item, index) in record.gradeClassList" :key="item.id">
              {{ item.className }}
            </div>
          </div>
          <span slot="birthday" slot-scope="text, record">
            {{ text.birthday && text.birthday.split(' ')[0] }}
          </span>
          <span slot="enabled" slot-scope="text, record">
            {{ text.enabled ? '启用' : '禁用' }}
          </span>
        </a-table>
      </div>
      <div v-else>
        <a-form-model layout="inline" :model="merge.search" class="search-form">
          <a-form-model-item label="所属机构">
            <a-select @change="() => this.getMergeList(1)" :filter-option="filterOption" allowClear showSearch v-model="merge.search.organizationId" placeholder="请选择机构">
              <a-select-option :value="item.id" v-for="item in organizationList">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="学生姓名">
            <a-input v-model="merge.search.name" placeholder="请输入" />
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" @click="getMergeList(1)">查询</a-button>
          </a-form-model-item>
        </a-form-model>

        <div class="TABLE">
          <div class="switch">
            <div>
              <span>性别</span>
              <a-switch default-checked @change="genderChange" v-model="merge.search.genderFilter" />
            </div>
            <div>
              <span>出生日期</span>
              <a-switch default-checked @change="birthdayChange" v-model="merge.search.birthdayFilter" />
            </div>
          </div>
          <a-table
            :scroll="{ y: 350 }"
            row-key="index"
            :key="merge.tableRelevant.key"
            :row-selection="studentRowKeys"
            :columns="noPickColumns"
            :defaultExpandAllRows="true"
            :pagination="merge.tableRelevant.tablePagination"
            :loading="merge.tableRelevant.tableLoading"
            :locale="merge.tableRelevant.locale"
            :data-source="merge.tableRelevant.tableDataSource"
          >
            <ChildTable
              slot="expandedRowRender"
              :selectUser="text.selectUser"
              :disabled="text.checked"
              :key="text.key || Date.now()"
              @selectUserChange="selectUserChange"
              :dataSource="text.organizationUsers"
              slot-scope="text"
            ></ChildTable>
          </a-table>
        </div>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import { CheckPhone, tableRelevant } from '@/pages/projectImpl/js/utils'
import ChildTable from './components/ChildTable'
import moment from 'moment'
import XLSX from 'xlsx'
import Apis from '@/requests/apis'

const columns = [
  {
    title: '学生姓名',
    key: '1',
    dataIndex: 'realName',
  },
  {
    title: '所属机构',
    dataIndex: 'organizationName',
  },
  {
    title: '性别',
    key: '2',
    scopedSlots: { customRender: 'gender' },
  },
  {
    title: '年级',
    key: '3',
    scopedSlots: { customRender: 'gradeName' },
  },
  {
    title: '班级',
    key: '4',
    class: 'testClass',
    align: 'center',
    scopedSlots: { customRender: 'className' },
  },
  {
    title: '手机号',
    key: '5',
    dataIndex: 'mobile',
  },
  {
    title: '出生日期',
    key: '6',
    scopedSlots: { customRender: 'birthday' },
  },

  {
    title: '创建时间',
    key: '7',
    dataIndex: 'createTime',
  },
  {
    title: '状态',
    key: '8',
    scopedSlots: { customRender: 'enabled' },
  },
  {
    title: '操作',
    key: '9',
    scopedSlots: { customRender: 'action' },
  },
]
const noPickColumns = [
  {
    title: '姓名',
    key: '1',
    dataIndex: 'name',
  },
]

export default {
  name: 'StudentsManage',
  components: { ChildTable },
  data() {
    const IDCard = (rule, value, callback) => {
      if (value && !/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        return callback(new Error('请输入正确的身份证号码'))
      }
      return callback()
    }
    return {
      columns,
      moment,
      uploadAction: process.env.VUE_APP_API_BASE_URL + Apis.File.upload + '?filePath=user/face',
      organizationList: [],
      searchGradeList: [],
      searchForm: {
        realName: this.$route.query.realName,
        mobile: this.$route.query.mobile,
        gradeId: Number(this.$route.query.gradeId) || undefined,
        classId: Number(this.$route.query.classId) || undefined,
        organizationId: Number(this.$route.query.organizationId) || undefined,
        gradeClass: undefined,
      },
      //批量删除选中的学生
      selectedRowKeys: [],
      classList: {
        teach: [], //教学班
        admin: [], //行政班
      },
      //表格相关
      tableRelevant: tableRelevant.call(this),
      //添加编辑学生相关
      studentRelevant: {
        title: '编辑学生',
        visible: false,
        confirmLoading: false,
        uploadLoading: false,
        editGradeId: '',
        gradeList: [],
        data: {
          id: undefined,
          faceUrl: undefined,
          organizationId: undefined,
          gradeId: undefined,
          classIds: [], //教学班
          administrationClassId: undefined, //行政班
          realName: '',
          studentNumber: '',
          gender: '1',
          idCard: '',
          birthday: undefined,
          mobile: '',
          enabled: 'true',
          // testUser:false
        },
        rules: {
          // testUser: [{required: true, message: '请选择', trigger: 'change'}],
          gradeId: [{ required: true, message: '请选择年级', trigger: 'change' }],
          studentNumber: [{ min: 6, max: 40, message: '请输入不小于6位的数字', trigger: 'blur' }],
          realName: [
            { required: true, message: '请输入学生姓名', trigger: 'blur' },
            { min: 2, max: 25, message: '学生姓名长度 2 到 25 个字符', trigger: 'change' },
          ],
          idCard: [{ required: false, validator: IDCard, trigger: 'blur' }],
          birthday: [{ required: true, message: '请选择出生日期', trigger: 'change' }],
          mobile: [{ required: false, validator: CheckPhone, trigger: 'change' }],
        },
      },

      // 合并学生
      mergeColumns: columns.filter((f) => !['所属机构', '操作'].includes(f.title)),
      noPickColumns,
      merge: {
        visible: false,
        confirmLoading: false,
        tableRelevant: tableRelevant.call(this, this.getMergeList),
        studentRowKey: [],
        rowKeys: [],
        childRowKey: [],
        search: {
          name: '',
          organizationId: undefined,
          genderFilter: false,
          birthdayFilter: false,
        },
      },
    }
  },
  created() {
    this.getAllOrg()
    this.getGradeList()
    this.getPageList()
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
        },
        getCheckboxProps: (record) => ({
          props: {
            disabled: !record.canOperate,
          },
        }),
      }
    },
    mergeSelection() {
      return {
        type: 'radio',
        selectedRowKeys: this.merge.rowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.merge.rowKeys = selectedRowKeys
        },
      }
    },
    studentRowKeys() {
      return {
        selectedRowKeys: this.merge.studentRowKey,
        onChange: (selectedRowKeys, selectedRows) => {
          this.merge.studentRowKey = selectedRowKeys
        },
        onSelect: (record, selected) => {
          record.checked = selected
          record.key = Date.now()
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          changeRows.forEach((v) => {
            v.checked = selected
            v.key = Date.now()
          })
        },
      }
    },
  },
  methods: {
    //获取年级列表
    getGradeList(val) {
      this.searchForm.gradeId = undefined
      this.searchForm.classId = undefined
      if (!this.searchForm.organizationId) {
        this.searchGradeList = []
        return
      }
      this.$http.CommonInterface.getGradeClass({ organizationId: this.searchForm.organizationId }).then((res) => {
        const { data } = res
        this.searchGradeList = tree(data)
      })

      function tree(arr) {
        return arr.map((m) => {
          if (m.children && m.children.length) {
            m.children = tree(m.children)
          } else {
            m.children = undefined
          }
          return m
        })
      }
    },
    searchGradeChange(val) {
      this.searchForm.gradeId = val[0]
      this.searchForm.classId = val[1]
    },
    filterOption(input, option) {
      const re = new RegExp(`[${input}]`, 'g')
      const match = option.componentOptions.children[0].text.match(re)
      if (match) {
        return match.length >= input.length
      }
      return false
    },
    // 获取机构列表
    getAllOrg() {
      this.$http
        .loadAllByType({
          type: 0,
        })
        .then((res) => {
          const { data } = res.data
          this.organizationList = data
        })
    },
    selectUserChange(selectedRowKeys, selectedRows) {
      this.merge.tableRelevant.tableDataSource.forEach((v) => {
        v.organizationUsers.forEach((m) => {
          if (v.users.includes(selectedRowKeys[0])) {
            v.selectUser = selectedRowKeys
          }
        })
      })
    },
    genderChange() {
      this.merge.tableRelevant.tableLoading = true
      this.getMergeList(1)
    },
    birthdayChange() {
      this.merge.tableRelevant.tableLoading = true
      this.getMergeList(1)
    },
    closeMerge() {
      this.merge.visible = false
      this.selectedRowKeys = []
      this.merge.rowKeys = []
      this.merge.tableRelevant.tableDataSource = []
      this.merge.studentRowKey = []
      this.merge.search = {
        name: '',
        organizationId: undefined,
        genderFilter: false,
        birthdayFilter: false,
      }
    },
    // 合并学生
    mergeStudent() {
      this.$message.destroy()
      if (this.selectedRowKeys.length) {
        if (this.selectedRowKeys.length < 2) {
          this.$message.warning('请至少选择2个学生')
          return
        }
        this.merge.tableRelevant.tableDataSource = this.selectedRowKeys
          .map((m) => {
            const item = JSON.parse(m)
            item.times = new Date(item.createTime).getTime()
            return item
          })
          .sort((a, b) => {
            return b.times - a.times
          })
        this.merge.rowKeys = [this.merge.tableRelevant.tableDataSource[0].id]

        if (this.merge.tableRelevant.tableDataSource.filter((f) => f.organizationId !== this.merge.tableRelevant.tableDataSource[0].organizationId).length) {
          this.$message.warning('请选择相同机构的学生')
          this.merge.tableRelevant.tableDataSource = []
          return
        }
      } else {
        this.merge.search.organizationId = this.searchForm.organizationId
        this.getMergeList(1)
      }
      this.merge.visible = true
    },
    // 获取合并学生列表
    getMergeList(index) {
      if (!this.merge.search.organizationId) {
        this.merge.tableRelevant.tableDataSource = []
        return
      }
      let params = {
        pageIndex: index || this.merge.tableRelevant.tablePagination.current,
        pageSize: this.merge.tableRelevant.tablePagination.pageSize,
        ...this.merge.search,
      }
      this.$http.UserManage.MergeOrganizationUserPageList(params)
        .then((res) => {
          const { data } = res
          data.items.forEach((v, i) => {
            v.checked = true
            v.index = i
            v.selectUser = [v.organizationUsers[0].id]
            v.users = []
            v.organizationUsers.forEach((m) => {
              v.users.push(m.id)
            })
            this.merge.studentRowKey.push(i)
          })
          this.merge.tableRelevant.tableDataSource = data.items
          this.merge.tableRelevant.key = Date.now()
          this.merge.tableRelevant.tablePagination.total = data.totalCount
          this.merge.tableRelevant.tablePagination.current = data.pageIndex
        })
        .finally(() => {
          this.merge.tableRelevant.tableLoading = false
        })
    },
    submitMerge() {
      this.$message.destroy()
      let params = {}
      if (this.selectedRowKeys.length) {
        if (!this.merge.rowKeys.length) {
          this.$message.warning('请选择主体学生')
          return
        }
        let item = this.merge.tableRelevant.tableDataSource.filter((f) => f.id == this.merge.rowKeys)[0]
        let arr = []
        this.merge.tableRelevant.tableDataSource.forEach((v) => {
          if (v.id != this.merge.rowKeys[0]) {
            arr.push(v.id)
          }
        })
        params = {
          organizationId: item.organizationId,
          mergeOrganizationUserIdPairs: [
            {
              organizationUserId: this.merge.rowKeys[0], //选中的主体ID
              organizationUserIds: arr, //除主体ID外的其他id
            },
          ],
        }

        if (item.userId != null) {
          params.mergeOrganizationUserIdPairs[0].userId = item.userId
        }
      } else {
        params = {
          organizationId: this.merge.search.organizationId,
          mergeOrganizationUserIdPairs: [],
        }
        this.merge.tableRelevant.tableDataSource.forEach((v) => {
          let str = {
            organizationUserId: v.selectUser[0],
            organizationUserIds: v.users.filter((f) => f != v.selectUser[0]),
          }
          let item = v.organizationUsers.filter((f) => f.id == v.selectUser[0])[0]
          if (item.userId) {
            str.userId = item.userId
          }
          params.mergeOrganizationUserIdPairs.push(str)
        })
      }
      this.$http.UserManage.MergeOrganizationUser(params).then((res) => {
          this.$message.success('操作成功')
          this.merge.visible = false
          this.getPageList(1)
          this.closeMerge()
       
      })
    },

    //获取学生列表
    getPageList(pageIndex) {
      const params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      params.gradeClass = undefined
      this.$router.push({
        query: {
          ...this.$route.query,
          ...this.searchForm,
          gradeClass: undefined,
        },
      })
      this.tableRelevant.tableLoading = true
      this.$http.User.getOrganizationUserPageList(params)
        .then((res) => {
          const { data, status, message } = res
          this.tableRelevant.tableDataSource = data.items
          this.tableRelevant.tablePagination.total = data.totalCount
          this.tableRelevant.tablePagination.current = data.pageIndex
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },

    //获取班级列表
    getClassList(val) {
      if (!val) {
        const classList = this.studentRelevant.gradeList.filter((f) => f.id === val.gradeId)[0].children
        this.classList.admin = classList.filter((v) => v.structureType === 1)
        this.classList.teach = classList.filter((v) => v.structureType === 2)
        return
      }

      return new Promise((resolve, reject) => {
        this.$http.CommonInterface.getGradeClass({ organizationId: val.organizationId })
          .then((res) => {
            const { data, status, message } = res
            this.studentRelevant.gradeList = data
            const classList = data.filter((f) => f.id === val.gradeId)[0].children
            this.classList.admin = classList.filter((v) => v.structureType === 1)
            this.classList.teach = classList.filter((v) => v.structureType === 2)
            resolve(classList)
          })
          .catch((e) => reject(false))
      })
    },

    //重置
    searchReset() {
      this.searchGradeList = []
      for (let key in this.searchForm) {
        this.searchForm[key] = undefined
      }
      this.getPageList(1)
    },

    //批量删除学生
    deleteAll() {
      this.$message.destroy()
      const that = this
      if (!this.selectedRowKeys.length) {
        this.$message.error('请选择要删除的学生')
        return
      }
      this.$confirm({
        title: `确认删除选中的 ${that.selectedRowKeys.length} 个学生？`,
        okType: 'danger',
        centered: true,
        onOk() {
          that.tableRelevant.tableLoading = true
          that.$http.UserManage.deleteStudentsAll(that.selectedRowKeys.map((m) => JSON.parse(m).id))
            .then((res) => {
              const { data, status, message } = res
              that.$message.success(message)
              that.selectedRowKeys = []
              that.getPageList(1)
            })
            .finally(() => {
              that.tableRelevant.tableLoading = false
            })
        },
      })
    },

    //新增修改学生
    studentRelevantOk() {
      this.$message.destroy()
      this.$refs.studentRelevantForm.validate((valid) => {
        if (valid) {
          if (!(this.studentRelevant.data.administrationClassId || this.studentRelevant.data.classIds.length)) {
            this.$message.error('请选择班级')
            return
          }
          const Ajax = this.studentRelevant.title === '编辑学生' ? this.$http.UserManage.updateStudent : this.$http.UserManage.addStudent
          this.studentRelevant.data.birthday = moment(this.studentRelevant.data.birthday).format('YYYY-MM-DD')
          this.studentRelevant.data.enabled = this.studentRelevant.data.enabled === 'true'
          // if (this.studentRelevant.data.administrationClassId){
          //     this.studentRelevant.data.classIds.push(this.studentRelevant.data.administrationClassId)
          // }
          this.studentRelevant.confirmLoading = true
          Ajax({
            ...this.studentRelevant.data,
            classIds: [...this.studentRelevant.data.classIds, this.studentRelevant.data.administrationClassId].filter((f) => !!f),
          })
            .then((res) => {
              const { data, status, message } = res
                this.$message.success(message)
                this.studentRelevantCancel()
                this.getPageList()
             
            })
            .finally(() => {
              this.studentRelevant.confirmLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //新增修改学生弹出层关闭
    studentRelevantCancel() {
      this.studentRelevant.visible = false
      this.studentRelevant.uploadLoading = false
      this.studentRelevant.data = {
        id: undefined,
        faceUrl: undefined,
        organizationId: this.organizationId,
        gradeId: undefined,
        classIds: [], //教学班
        administrationClassId: undefined, //行政班
        realName: '',
        studentNumber: '',
        gender: '1',
        idCard: '',
        birthday: undefined,
        mobile: '',
        enabled: 'true',
      }
      this.classList = {
        teach: [], //教学班
        admin: [], //行政班
      }
      this.$refs.studentRelevantForm.resetFields()
    },
    //编辑学生
    edit(val) {
      this.studentRelevant.title = '编辑学生'
      for (let key in this.studentRelevant.data) {
        for (let key2 in val) {
          if (key === key2) {
            this.studentRelevant.data[key] = val[key2] || undefined
          }
        }
      }
      this.studentRelevant.data.gender = String(val.gender)
      this.studentRelevant.data.gradeId = val.gradeClassList[0].gradeId || undefined
      this.studentRelevant.data.administrationClassId = val.gradeClassList.filter((v) => v.classType === 1).map((m) => m.classId)[0]
      this.studentRelevant.data.classIds = val.gradeClassList.filter((v) => v.classType === 2).map((m) => m.classId)
      this.studentRelevant.data.enabled = String(val.enabled)
      if (this.studentRelevant.data.gradeId) {
        this.studentRelevant.editGradeId = this.studentRelevant.data.gradeId
        this.getClassList(this.studentRelevant.data).then((data) => {
          if (data) {
            this.classList.admin = data.filter((v) => v.structureType === 1)
            this.classList.teach = data
              .filter((v) => v.structureType === 2)
              .map((m) => {
                return {
                  ...m,
                  // disabled: this.studentRelevant.data.classIds.includes(m.id)
                }
              })
          }
        })
      }
      this.studentRelevant.visible = true
    },
    // 用户详情
    studentDetail(val) {
      this.$router.push({
        path: '/projectImpl/StudentsManage/pStudentDetails',
        query: {
          id: val.id,
          organizationId: val.organizationId,
          classId: val.gradeClassList[0]?.classId,
          fullPath: window.encodeURIComponent(this.$route.fullPath),
        },
      })
    },
    //删除学生
    del(val) {
      this.tableRelevant.tableLoading = true
      this.$http.UserManage.deleteStudentsAll([val.id])
        .then((res) => {
          const { data, status, message } = res
            this.$message.success(message)
            this.selectedRowKeys = []
            this.getPageList()
         
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    //启用禁用学生
    tableStatusChange(val) {
      const formData = new FormData()
      formData.append('organizationUserId', val.id)
      formData.append('enabled', val.enabled)
      this.tableRelevant.tableLoading = true
      this.$http.UserManage.studentState(formData)
        .then((res) => {
          this.$message.success(res.message)
        })
        .catch(() => {
          val.enabled = !val.enabled
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },

    // 学生头像上传
    headHandleChange(info) {
      if (info.file.status === 'uploading') {
        this.studentRelevant.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        if (info.file.response.status) {
          this.studentRelevant.data.faceUrl = info.file.response.data
        } else {
          this.$message.error(info.file.message)
        }
        this.studentRelevant.uploadLoading = false
      }
    },
    headBeforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('请上传jpg或者png格式图片')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!')
      }
      return isJpgOrPng && isLt2M
    },
  },
}
</script>

<style scoped>
.serach-item {
  width: 180px;
  margin-bottom: 15px;
}

.update-students >>> .ant-upload-list-item-card-actions {
  display: none;
}

/deep/ .ant-table-tbody .testClass {
  padding: 0 !important;
}

/*#StudentsManage >>> .studentClassTooltip .ant-tooltip-inner, #StudentsManage >>> .studentClassTooltip .ant-tooltip-arrow::before {
    background-color: #fff;
}

.studentClassTooltipBtn {
    height: auto;
    font-size: 12px;
    padding: 0 6px;
}*/

.self_td {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
}

.tags {
  display: none;
}

.self_td:hover .tags {
  display: block;
}

.ageCheck {
  display: flex;
  padding: 0 30px;
  margin-bottom: 35px;
}

.ageCheck span {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.TABLE {
  position: relative;
}

.switch {
  display: flex;
  width: 400px;
  justify-content: space-between;
  position: absolute;
  top: 15px;
  left: 230px;
  z-index: 9;
}

.switch div {
  display: flex;
  align-items: center;
}

.switch div span {
  margin-right: 5px;
}
</style>
